module.exports = __webpack_public_path__ + "static/media/JJB.05adc23c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/JJB.jpg
// module id = 193
// module chunks = 0